// AddContents.js
import React from 'react';
import FlexBoxes from './flexboxes/FlexBoxes'; 

function AddContents() {
  console.log('[AddContents] starting');
  return (
    <FlexBoxes />
  );
}

export default AddContents;